<template>
  <v-toolbar
    color="primary"
    fixed
    class="main--text"
  >
    <v-toolbar-title
      class="white--text title--text"
      style="cursor:pointer"
      @click="$router.push({path: '/'})">
      Prosense
    </v-toolbar-title>

    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>
